import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Severity, SeverityHelper } from '@libs/vc-core-lib';
import { BadgeComponent, BadgeStatus, BadgeTooltipPosition, TextRendererPipe } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-severity-badge-renderer',
    templateUrl: './severity-badge-renderer.component.html',
    styleUrls: ['./severity-badge-renderer.component.scss'],
    imports: [TextRendererPipe, BadgeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeverityBadgeRendererComponent {
    badgeStatus!: BadgeStatus;
    statusIcon!: string;
    severityRenderer = (severity: Severity) => SeverityHelper.getSeverityLocale(severity);

    @Input()
    set severity(value: Severity) {
        this._severity = value;
        this._setBadgeStatusColor(value);
    }
    get severity(): Severity {
        return this._severity;
    }
    private _severity!: Severity;

    @Input()
    showTooltip: boolean = true;

    @Input()
    tooltipPosition: BadgeTooltipPosition = 'below';

    private _setBadgeStatusColor(status: Severity) {
        switch (status) {
            case Severity.CRITICAL:
                this.badgeStatus = 'error';
                this.statusIcon = 'keyboard_double_arrow_up';
                return;
            case Severity.HIGH:
                this.badgeStatus = 'error';
                this.statusIcon = 'expand_less';
                return;
            case Severity.MEDIUM:
                this.badgeStatus = 'warning';
                this.statusIcon = 'drag_handle';
                return;
            case Severity.LOW:
                this.badgeStatus = 'success';
                this.statusIcon = 'keyboard_double_arrow_down';
                return;
            case Severity.INFO:
                this.badgeStatus = 'info';
                this.statusIcon = 'info';
                return;
            case Severity.UNKNOWN:
                this.badgeStatus = 'neutral';
                this.statusIcon = 'help_outline';
                return;
            default:
                return;
        }
    }
}
